/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AutoPostKartePlannerCommentSettingInput = {
  comment: string;
  enabled: boolean;
  selections: Array<string>;
};

export type SettingsPageAutoPostKartePlannerCommentViewViewerFragment = { profile: { comment: string, avatar: any }, autoPostKartePlannerComment: { available: boolean, setting: { enabled: boolean, comment: string, selections: Array<string> } | null } };

export type PreviewAutoPostKartePlannerCommentSettingMutationVariables = Exact<{
  setting: Types.AutoPostKartePlannerCommentSettingInput;
}>;


export type PreviewAutoPostKartePlannerCommentSettingMutation = { previewAutoPostKartePlannerCommentSetting: { maybeUserNames: Array<string> } };

export type UpdateSettingsPageAutoPostKartePlannerCommentMutationVariables = Exact<{
  input: Types.AutoPostKartePlannerCommentSettingInput;
}>;


export type UpdateSettingsPageAutoPostKartePlannerCommentMutation = { updateAutoPostKartePlannerCommentSetting: { enabled: boolean, comment: string, selections: Array<string> } };

export const SettingsPageAutoPostKartePlannerCommentViewViewerFragmentDoc = gql`
    fragment SettingsPageAutoPostKartePlannerCommentViewViewer on Viewer {
  profile {
    comment
    avatar
  }
  autoPostKartePlannerComment {
    available
    setting {
      enabled
      comment
      selections
    }
  }
}
    `;
export const PreviewAutoPostKartePlannerCommentSettingDocument = gql`
    mutation previewAutoPostKartePlannerCommentSetting($setting: AutoPostKartePlannerCommentSettingInput!) {
  previewAutoPostKartePlannerCommentSetting(setting: $setting) {
    maybeUserNames
  }
}
    `;

/**
 * __usePreviewAutoPostKartePlannerCommentSettingMutation__
 *
 * To run a mutation, you first call `usePreviewAutoPostKartePlannerCommentSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePreviewAutoPostKartePlannerCommentSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePreviewAutoPostKartePlannerCommentSettingMutation({
 *   variables: {
 *     setting: // value for 'setting'
 *   },
 * });
 */
export function usePreviewAutoPostKartePlannerCommentSettingMutation(options: VueApolloComposable.UseMutationOptions<PreviewAutoPostKartePlannerCommentSettingMutation, PreviewAutoPostKartePlannerCommentSettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PreviewAutoPostKartePlannerCommentSettingMutation, PreviewAutoPostKartePlannerCommentSettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PreviewAutoPostKartePlannerCommentSettingMutation, PreviewAutoPostKartePlannerCommentSettingMutationVariables>(PreviewAutoPostKartePlannerCommentSettingDocument, options);
}
export type PreviewAutoPostKartePlannerCommentSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PreviewAutoPostKartePlannerCommentSettingMutation, PreviewAutoPostKartePlannerCommentSettingMutationVariables>;
export const UpdateSettingsPageAutoPostKartePlannerCommentDocument = gql`
    mutation updateSettingsPageAutoPostKartePlannerComment($input: AutoPostKartePlannerCommentSettingInput!) {
  updateAutoPostKartePlannerCommentSetting(setting: $input) {
    enabled
    comment
    selections
  }
}
    `;

/**
 * __useUpdateSettingsPageAutoPostKartePlannerCommentMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsPageAutoPostKartePlannerCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsPageAutoPostKartePlannerCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSettingsPageAutoPostKartePlannerCommentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettingsPageAutoPostKartePlannerCommentMutation(options: VueApolloComposable.UseMutationOptions<UpdateSettingsPageAutoPostKartePlannerCommentMutation, UpdateSettingsPageAutoPostKartePlannerCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSettingsPageAutoPostKartePlannerCommentMutation, UpdateSettingsPageAutoPostKartePlannerCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSettingsPageAutoPostKartePlannerCommentMutation, UpdateSettingsPageAutoPostKartePlannerCommentMutationVariables>(UpdateSettingsPageAutoPostKartePlannerCommentDocument, options);
}
export type UpdateSettingsPageAutoPostKartePlannerCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSettingsPageAutoPostKartePlannerCommentMutation, UpdateSettingsPageAutoPostKartePlannerCommentMutationVariables>;